import { useEffect, useRef, useState } from 'react';
export const useCountdown = (defaultTime) => {
    const secondsRef = useRef(defaultTime !== null && defaultTime !== void 0 ? defaultTime : 0);
    const [timeLeft, setTimeLeft] = useState(null);
    const timer = useRef(0);
    const secondsToTime = (secs) => {
        if (secs < 0) {
            return { minutes: 0, seconds: 0 };
        }
        const divisor_for_minutes = secs % (60 * 60);
        const minutes = Math.floor(divisor_for_minutes / 60);
        const divisor_for_seconds = divisor_for_minutes % 60;
        const seconds = Math.ceil(divisor_for_seconds);
        const obj = {
            minutes,
            seconds,
        };
        return obj;
    };
    useEffect(() => {
        if (timer.current === 0 && secondsRef.current > 0) {
            timer.current = window.setInterval(() => {
                secondsRef.current -= 1;
                setTimeLeft(secondsToTime(secondsRef.current));
                // Check if we're at zero.
                if (secondsRef.current === 0) {
                    clearInterval(timer.current);
                }
            }, 1000);
        }
    }, []);
    useEffect(() => {
        return () => clearInterval(timer.current);
    }, []);
    // Resets the countdown when the hook parameter changes
    useEffect(() => {
        if (defaultTime) {
            secondsRef.current = defaultTime;
        }
    }, [defaultTime]);
    return { minutes: timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.minutes, seconds: timeLeft === null || timeLeft === void 0 ? void 0 : timeLeft.seconds };
};
